import { styled } from 'stitches.config';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

export const Trigger = styled(CollapsiblePrimitive.Trigger, {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',

  svg: {
    width: '12px',
    path: {
      fill: '$colorGreyLv5',
    },
  },
});
